import React from 'react';

import { Total } from './Total';
import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { ServicesPerYearDonut } from './ServicesPerYearDonut';
import { ServicesPerYearPercentage } from './ServicesPerYearPercentage';
import { ServicesPerMonthPerYearPercentage } from './ServicesPerMonthPerYearPercentage';
import './styles/Charts.css';

const Totals = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="side-by-side-group">
                <Total />
                <div className="right-group">
                    <ServicesPerYearDonut />
                </div>
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearPercentage />
                <ServicesPerMonthPerYearPercentage />
            </div>
        </>
    );
};

export default Totals;
